<template>
    <div>
        <v-layout align-center class="mb-3">
            <v-text-field
                v-model="searchKey"
                prepend-inner-icon="mdi-magnify"
                :placeholder="$filters.capitalize($t('searchBy.labelOrDescription'))"
                hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn class="mx-0" @click="createItem" v-if="isEditable">{{ $t('new') }}</v-btn>
        </v-layout>
        <SimpleDataTable
            :headers="intentHeaders"
            :items="filterIntentList"
            :pagination="pagination"
        >
            <template v-slot:action="props">
                <v-btn icon @click="editItem(props.item)"><v-icon>mdi-pencil</v-icon></v-btn>
                <v-btn icon @click="deleteItem(props.item)"><v-icon>mdi-delete</v-icon></v-btn>
                <v-btn @click="gotoSample(props.item)" outline>{{ $t('sample') }}</v-btn>
            </template>
        </SimpleDataTable>
    </div>
</template>

<script>
import SimpleDataTable from "@/modules/fptai/components/SimpleDataTable";
import { mapState } from "vuex";
import { ScenarioEventBus, ScenarioEventBusType } from "@/views/Scenario/scenario.eventbus";
import NLP_Service from "@/services/nlp.service";
import ScenarioService from "@/services/scenario.service";

export default {
    name: "IntentList",
    components: { SimpleDataTable },
    data () {
        return {
            searchKey: '',
            pagination: {
                rowsPerPage: 10,
                page: 1
            }
        }
    },
    computed: {
        ...mapState({
            intentList: state => state.scenario.intentList
        }),
        filterIntentList () {
            let search = this.$utils.nonAccentVietnamese(this.searchKey)
            if (search) {
                return this.intentList.filter(item =>
                    item.label.toLowerCase().includes(search) ||
                    this.$utils.nonAccentVietnamese(item.description).includes(search)
                )
            }
            return this.intentList
        },
        intentHeaders () {
            return this.$appService.correctHeaders([
                {
                    text: this.$t('label'),
                    value: 'label'
                },
                {
                    text: this.$t('description'),
                    value: 'description'
                },
                {
                    text: this.$t('action'),
                    value: 'action',
                    type: 'custom',
                    id: 'action',
                    visible: this.isEditable
                }
            ])
        },
        isEditable: () => ScenarioService.isEditable()
    },
    methods: {
        searchItem () {
            this.$store.dispatch(this.$actionTypes.scenario.GET_INTENT_LIST, this.$route.params.scenarioId)
        },
        createItem () {
            ScenarioEventBus.$emit(ScenarioEventBusType.CREATE_INTENT, {
                item: null,
                resolve: this.searchItem
            })
        },
        editItem (item) {
            ScenarioEventBus.$emit(ScenarioEventBusType.CREATE_INTENT, {
                item,
                resolve: this.searchItem
            })
        },
        deleteItem (item) {
            this.$appService.confirm(this.$t('confirmDelete', { item: this.$t('intent') + ': ' + item.label })).then(
                () => {
                    let i18n = {
                        action: this.$t('delete'),
                        item: this.$t('intent')
                    }
                    this.$appService.showLoading()
                    NLP_Service.IntentService.delete(this.$route.params.scenarioId, item.label).then(
                        () => {
                            this.$appService.toastSuccess(this.$t('actionSuccessful', i18n))
                            this.searchItem()
                        },
                        this.$appService.handleRequestError(this.$t('actionFailed', i18n))
                    ).finally(this.$appService.hideLoading)
                }
            )
        },
        gotoSample (item) {
            this.$emit('sample', { intent: item.label })
        }
    }
}
</script>

<style scoped>

</style>
